/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table as TableType, flexRender } from '@tanstack/react-table';

import { cn } from '../../lib/utils';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

interface DataTableProps<T> {
  table: TableType<T>;
  emptyDescription?: string;
}

const DataTable = <T,>(props: DataTableProps<T>) => {
  const { table, emptyDescription } = props;

  return (
    <div className="rounded-md border">
      <Table className="border-collapse !border-spacing-0 border-solid  border relative">
        <TableHeader className="sticky top-0 flex-1 border ">
          {table.getHeaderGroups().map(headerGroup => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                return (
                  <TableHead
                    key={header.id}
                    className={cn(
                      'bg-gray-50 text-nowrap first:pl-4 last:pr-4 text-left text-xs',
                      (header.column.columnDef.meta as any)?.className ?? '',
                    )}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                  </TableHead>
                );
              })}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody className="[&_tr:last-child_td]:pb-3">
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map(row => (
              <TableRow
                key={row.id}
                data-state={row.getIsSelected() && 'selected'}
                className="hover:bg-gray-50"
              >
                {row.getVisibleCells().map(cell => (
                  <TableCell key={cell.id} className="py-1.5 first:pl-4 last:pr-4 text-left text-xs">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={table.getAllColumns().length}
                className="h-24 text-center border w-full"
              >
                {emptyDescription ?? '데이터가 없습니다.'}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default DataTable;
